<template>
  <div v-if="placeContext">
    <header v-if="1 == $route.query.hl" class="container text-center mt-3 mb-5">
      <img :src="placeContext.logo_path" class="img-fluid" />
    </header>

    <router-view></router-view>
  </div>
</template>

<script>
import { mainEventBus, userEventBus } from './events/bus'
import ApiService from './services/api'

export default {
  name: 'App',

  created() {
    if (this.$route.query.c) {
      ApiService.init(this.$route.query.c)
    }
    if (this.$route.query.pc) {
      this.$store.dispatch('setPlaceCode', this.$route.query.pc)
    }
    const eventLocale = this.$route.query.f ? this.$route.query.f.split(',') : ['fr']
    this.$store.dispatch('setWorkshopsLocales', eventLocale)

    if (this.$route.query.ut) {
      this.$store.dispatch('setUserToken', this.$route.query.ut)
      ApiService.getSession()
        .then(response => {
          this.$store.dispatch('setUser', response.data)
          userEventBus.$emit('user.logged')
        })
        .catch(() => this.$swal(this.$i18n.t('errors.base')))
    }
  },

  mounted() {
    mainEventBus.$on('placeContext.defined', () => {
      this.$i18n.locale = this.$route.query.l || this.placeContext.default_locale
    })

    mainEventBus.$on('placeContext.defined', () => {
      const placeContextColors = this.placeContext.custom_styles.colors

      document.documentElement.style.setProperty('--main-background-color', placeContextColors.mainPrimary)
      document.documentElement.style.setProperty('--primary', placeContextColors.mainPrimary)
    })

    userEventBus.$on('user.logged', () => {
      this.$i18n.locale = this.currentUser.locale
    })

    ApiService.getPlaceContext()
      .then(response => {
        this.$store.dispatch('setPlaceContext', response.data)
        mainEventBus.$emit('placeContext.defined')
      })

    if (!this.$route.query.pc && 'home' === this.$route.name) {
      return this.$router.push({ name: 'places.choice', query: this.$route.query })
    }
  },

  computed: {
    placeCode() {
      return this.$store.state.placeCode
    },
    placeContext() {
      return this.$store.state.placeContext
    },
    currentUser() {
      return this.$store.state.user
    }
  },
}
</script>

<style lang="scss">
  @import './scss/variables.scss';
  @import './scss/app.scss';
</style>
